import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { RootState } from '../../../../store/rootReducer';
import { INSURANCE_COMPANIES } from '../../../../constants';
import { ModalLopdStyles } from './modal-lopd-styles';

const ModalLegal: React.FC<any> = () => {
  const { t } = useTranslation(['lopd']);
  const providerCode = useSelector((state: RootState) => state.general.provider);
  if (!providerCode || (!INSURANCE_COMPANIES?.[providerCode] && providerCode === '00000016')) return <></>;
  return (
    <ModalLopdStyles>
      <div className="modal-lopd">
        <h1 className="modal-lopd-title">{t(`lopd:${providerCode}.title`)}</h1>
        <h2 className="modal-lopd-subtitle">{t(`lopd:${providerCode}.authorization`)}</h2>
        <ul>
          <li className="modal-lopd__section">
            <p className="modal-lopd__section-title">{t(`lopd:${providerCode}.insurances-part.title`)}</p>
            <p className="modal-lopd__section-text">{t(`lopd:${providerCode}.insurances-part.text`)}</p>
          </li>
          <li className="modal-lopd__section">
            <p className="modal-lopd__section-title">{t(`lopd:${providerCode}.data-protection.title`)}</p>
            <p className="modal-lopd__section-text">{t(`lopd:${providerCode}.data-protection.text`)}</p>
          </li>
          <li className="modal-lopd__section">
            <p className="modal-lopd__section-title">{t(`lopd:${providerCode}.purpose.title`)}</p>
            <p className="modal-lopd__section-text">{t(`lopd:${providerCode}.purpose.text`)}</p>
          </li>
          <li className="modal-lopd__section">
            <p className="modal-lopd__section-title">{t(`lopd:${providerCode}.legitimation.title`)}</p>
            <p className="modal-lopd__section-text">{t(`lopd:${providerCode}.legitimation.text`)}</p>
          </li>
          <li className="modal-lopd__section">
            <p className="modal-lopd__section-title">{t(`lopd:${providerCode}.data-categories.title`)}</p>
            <p className="modal-lopd__section-text">{t(`lopd:${providerCode}.data-categories.text`)}</p>
          </li>
        </ul>
      </div>
    </ModalLopdStyles>
  );
};

export default ModalLegal;
